<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="查看出库单" left-arrow fixed
                     @click-left="back"/>
        <van-row>
            <van-col span="24" style="text-align: center" v-if="order.dgoList==null">
                暂无出库单信息
            </van-col>
        </van-row>
        <van-row v-for="(item,index) in order.dgoList">

            <van-collapse v-model="activeNames" class="pro-hd">
                <van-collapse-item :title="outName[index+1]" value="展开" :name="index">
                    <div class="pro-item">
                        <van-cell title="出库单号" :value="item.deliveryOrderNo"/>
                        <van-cell title="发货时间" :value="item.deliveryTime"/>
                        <van-cell title="收货时间" :value="item.arrivalTime"/>
                        <van-cell title="支付方式" :value="order.order.payClassName"/>
                        <div v-if="order.order.orderGoodsType!=1">
                            <van-cell title="司机手机号" :value="item.logistic.mobileDriver"/>
                            <van-cell title="发车时间" :value="item.logistic.departureTime"/>
                            <van-cell title="车次安排" :value="item.logistic.trainType==1?'专车':'拼车'"/>
                            <van-cell title="车牌号" :value="item.logistic.plateNo"/>
                            <van-cell title="司机姓名" :value="item.logistic.driverName"/>
                            <van-cell title="司机身份证号" :value="item.logistic.driverIdnumber"/>
                        </div>
                    </div>
                    <van-row style="color: #3C6EEB;margin-left: 10px;font-size: 14px">商品信息</van-row>
                    <van-row v-for="good in item.detailList">
                        <van-row style="margin-left: 10px;margin-right: 10px;color: black;">{{good.goodsName}}</van-row>
                        <van-col span="10" class="jump-cart-item-img">
                            <img :src="good.goodsPic" style="width:100%"/>
                        </van-col>
                        <van-col span="14" class="jump-cart-item-warp">
                            <van-cell title="商品单位" :value="good.goodsUnitSeller"/>
                            <van-cell title="出库数量" :value="good.outCount"/>
                            <van-cell title="出库数量" :value="good.deliveryPrice"/>
                            <van-row
                                    v-if="(order.order.orderGoodsType==3 || order.order.orderGoodsType==4)&& good.receivedCount >0">
                                <van-field
                                        v-model="istruegg[good.id]"
                                        readonly
                                        label="感官确认"
                                        placeholder="请选择"
                                        @focus="showPops(good.id)"
                                />
                            </van-row>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" v-if="item.deliveryGoodsorderStatus==3">
                            <van-button type="info" size="large" class="blues" @click="confirmDeliverySaveSense(index)">
                                确认收货
                            </van-button>
                        </van-col>
                    </van-row>
                </van-collapse-item>
            </van-collapse>
        </van-row>
        <van-popup v-model="popShows" position="bottom" :overlay="true">
            <van-picker
                    :columns="columns"
                    show-toolbar
                    value-key="name"
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
                    @change="onPickerChange"
            />
        </van-popup>
    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem, Picker, Popup} from "vant";

    export default {
        name: "userOrderArrival",
        components: {
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem
        },
        data() {
            return {
                activeNames: [0],
                orderId: this.$route.query.id,
                order: {},
                outIndex: 0,
                popShows: false,
                columns: [{name: '合格', id: 1}, {name: '不合格', id: 0}],
                istruegg: [],
                outName: [],
                bsid: '',
            };
        }, mounted: function () {
            this.receiveCheck()
        },
        methods: {
            showPops(id) {
                this.bsid = id
                this.popShows = true;
            },
            onPickerCancel() {
                this.popShows = false;
            }, onPickerConfirm(values) {
                this.istruegg[this.bsid] = values.name;
                this.popShows = false;
            },
            onPickerChange(picker, values) {
                picker.setColumnValue(1, values.name);
            },
            jiayi() {
                let that = this
                for (var i = 1; i <= that.order.dgoList.length; i++) {
                    that.outName[i] = '出库单' + i + '明细信息'
                    let detailList = that.order.dgoList[i - 1].detailList
                    for (let j = 0; j < detailList.length; j++) {
                        let senseCheck = detailList[j].senseCheck
                        senseCheck = senseCheck == '1' ? '合格' : '不合格'
                        that.istruegg[detailList[j].id] = senseCheck
                    }
                }
            },
            back() {
                history.back();
            }, receiveCheck() {
                let that = this
                that.$api.get(
                    that.jumuc.order.outOrder,
                    {"orderId": that.orderId},
                    successRes => {
                        that.order = successRes.data
                        that.jiayi()
                    }
                )
            },
            confirmDeliverySaveSense(index) {//确认出库
                let that = this
                localStorage.setItem("outOrderReceive", JSON.stringify({}));
                let dgoList = that.order.dgoList[index]
                let json = {}
                json['orderId'] = dgoList.orderId
                json['deliveryOrderId'] = dgoList.id
                let detailList = dgoList.detailList
                for (let i = 0; i < detailList.length; i++) {
                    let id = that.istruegg[detailList[i].id]
                    id = id == '合格' ? 1 : 0
                    json[detailList[i].id] = id
                }
                that.$api.post(that.jumuc.userCenter.confirmDeliverySaveSense,
                    json,
                    successRes => {
                        if (successRes.success) {
                            localStorage.setItem("outOrderReceive", JSON.stringify(successRes.data));
                            that.$router.push({
                                path: '/user/order/outreceive',
                            });
                        } else {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {

                            });
                        }

                    })
            }
        },
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;

    .jump-warphd {
        .pro-hd {
            .van-collapse-item__title {
                background-color: #f7f7f7;
                color: @bule-thame;
                .van-cell__value, i {
                    color: @bule-thame;
                }
            }
        }
        .van-collapse-item__content {
            padding: 0;
        }
        .pro-item {
            border-bottom: 5px solid #f7f7f7;
        }
        .p-tol {
            padding: 10px 10px 20px;
            color: @bule-thame;
            font-size: 14px;
            text-align: right;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
        .van-cell:not(:last-child)::after {
            border: none;
        }
        .jump-cart-item-warp {
            color: black;
        }
        p {
            margin-top: 12px;
        }
    }
</style>
